import { ChangeDetectionStrategy, Component, inject, Input, input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoComponent {
  private readonly sanitizer = inject(DomSanitizer);

  videoLink: SafeUrl = '';
  readonly legend = input<string>('');

  @Input() set videoEmbedLink(link: string) {
    this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }
}